<!--
 * @Description: 订单详情
 * @Author: zml
 * @Date: 2022-10-27 09:06:05
 * @LastEditors: xie
 * @LastEditTime: 2024-07-31 14:50:19
-->
<template>
  <div class="order-detail">
    <component :is="componentName"></component>
  </div>
</template>
<script>
import mixins from '@/utils/mixins'
export default {
  name: 'orderDetailPage',
  mixins: [mixins],
  data() {
    return {
      componentName: ''
    }
  },
  created() {
    this.initDom()
  },
  methods: {
    initDom() {
      switch (this.$templates()) {
        case 'themeTemplateOne':
          this.componentName = 'pageOrderDetailOne'
          break
        case 'themeTemplateTow':
          this.componentName = 'pageOrderDetailTow'
          break
        case 'themeTemplateThree':
          this.componentName = 'pageOrderDetailThree'
          break
        case 'themeTemplateFour':
          this.componentName = 'pageOrderDetailFour'
          break
        case 'themeTemplateFive':
          this.componentName = 'pageOrderDetailFive'
          break
        case 'themeTemplateSix':
          this.componentName = 'pageOrderDetailSix'
          break
        case 'themeTemplateSeven':
          this.componentName = 'pageOrderDetailSeven'
          break
        case 'themeTemplateEight':
          this.componentName = 'pageOrderDetailEight'
          break
        case 'themeTemplateNine':
          this.componentName = 'pageOrderDetailNine'
          break
        case 'themeTemplateTen':
          this.componentName = 'pageOrderDetailTen'
          break
        default:
          this.componentName = ''
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.order-detail {
  width: 100%;
  padding: 10px 0;
}
</style>